import "../../../src/scss/editorControls.scss";
import { itx } from "../../../src/translationItx/itx";
import type { ChannelType } from "../../../src/models/ChannelType";
import type { C1_LightProductId } from "../data/C1_ProductDefinitions";
import { C1_LightProductSelect } from "../components/C1_LightProductSelect";
import { C1_ChannelTypeSelect } from "./C1_ChannelTypeSelect";

/** Identische Leuchtenfelder für den Geräte-Editor und Leuchten im Ausstattungsbaum.
 * Die Aufrufer übernehmen die Speicherung im Consumer bzw. im bearbeiteten Baum.
 */
export function C1_LightEditorFields({
  name, onNameChange, channelType, isDali, channelTypeOptions,
  onChannelTypeChange, onDaliChange, lightProductId, lightProductIds, onLightProductChange,
}: {
  name: string;
  onNameChange: (name: string) => void;
  channelType: ChannelType;
  isDali: boolean;
  channelTypeOptions?: readonly ChannelType[];
  onChannelTypeChange: (value: ChannelType) => void;
  onDaliChange: (value: boolean) => void;
  lightProductId?: C1_LightProductId;
  lightProductIds: C1_LightProductId[];
  onLightProductChange: (value: C1_LightProductId | undefined) => void;
}) {
  return <div className="C1_lightEditDialog C1_lightEditorFields estada-editorFields">
    <label className="estada-editorField dockLabel">
      <span>{itx("c1.ui.Name", "Name")}</span>
      <input type="text" className="estada-editorControl dockControl" data-testid="c1-elo-name"
        value={name} onChange={(event) => onNameChange(event.target.value)}
        onBlur={() => globalThis.state.undoManager.userInteractionEnded()} />
    </label>
    <div className="C1_lightFunctionField estada-editorField">
      <span>{itx("c1.ui.Lichttyp", "Lichttyp")}</span>
      <C1_ChannelTypeSelect value={channelType} isDali={isDali} options={channelTypeOptions}
        onChannelTypeChange={onChannelTypeChange} onDaliChange={onDaliChange} />
    </div>
    <label className="estada-editorField dockLabel">
      <span>{itx("c1.ui.Bauform", "Bauform")}</span>
      <C1_LightProductSelect value={lightProductId} options={lightProductIds} onChange={onLightProductChange} />
    </label>
  </div>;
}
